module.exports = __webpack_public_path__ + "img/wechaterweima.2754bf13.jpg";